import { useEffect } from 'react';
import { BreadcrumbLocation, PrivatePage } from '../../components/private-page';
import AdminFacilitatorsGrid from '../../features/admin-facilitators-grid';
import { ctGameTitle, ctGameDefault } from '../../constants/text';

export default function AdminFacilitators() {
  const breadcrumbs: BreadcrumbLocation[] = [
    { label: 'Dashboard', href: '/' },
    { label: 'Administration', href: '../administration' },
    { label: 'Facilitator users', href: '../administration/facilitators' }
  ];

  useEffect(() => {
    document.title = ctGameTitle + ' - Facilitator Users';

    return () => {
      // return default value when component unmounts
      document.title = ctGameDefault;
    };
  }, []);

  return (
    <PrivatePage
      className={'page-base--full'}
      pageTitle={'Administration'}
      breadcrumb={breadcrumbs}>
      <AdminFacilitatorsGrid />
    </PrivatePage>
  );
}
